/* eslint-disable import/no-unresolved */
import React, { Component } from "react";
import { connect } from "react-redux";
import { bool, shape } from "prop-types";

import { selectors as transactionsSelectors } from "reducers/transactions";
import { withMultipleSignaturesContext } from "pages/transactions/MultipleSignaturesTables/MultipleSignaturesDataContext";
import * as configUtils from "util/config";
import { truncateWithEllipsis } from "util/string";
import { parseToAmountFormat, toNumber } from "util/number";

import { Tag } from "@ui-kit/components/index.es";

import I18n from "pages/_components/I18n";
import FormattedAmount from "pages/_components/FormattedAmount";
import CardContainer from "pages/_components/Card/CardContainer";
import Card from "pages/_components/Card/Card";

const getFirstNotBlank = (...values) => values.find((value) => typeof value === "string" && value.trim().length > 0);

const getEcomexBeneficiaryName = (data = {}) => {
    const transactionData = data.transactionData || {};
    return getFirstNotBlank(
        transactionData.beneficiaryName,
        transactionData.nombreBeneficiario,
        data.beneficiaryName,
        data.nombreBeneficiario,
    );
};

const getQuantityAndCurrency = (object) => {
    const amounts = object.transactionAmounts || {};
    const keys = Object.keys(amounts);
    if (keys.length > 0) {
        const currency = keys[0];
        return { currency, quantity: Number(amounts[currency]) || 0 };
    }
    const d = object.transaction?.data || {};
    const nestedAmount = d.amount && typeof d.amount === "object" ? d.amount : null;
    if (nestedAmount !== null && nestedAmount.quantity !== undefined && nestedAmount.quantity !== null) {
        return {
            currency: String(nestedAmount.currency ?? "0"),
            quantity: Number(nestedAmount.quantity) || 0,
        };
    }
    return { currency: "0", quantity: 0 };
};

const formatEcomexRequestAmount = (raw) => {
    if (raw === undefined || raw === null || raw === "") {
        return "";
    }
    if (typeof raw === "number") {
        return parseToAmountFormat(raw, 2, "es-AR");
    }
    const s = String(raw);
    const n = toNumber(s, ",", 2);
    if (typeof n === "string" || Number.isNaN(n)) {
        return s;
    }
    return parseToAmountFormat(n, 2, "es-AR");
};

class EcomexSendAcceptTransactionDataTable extends Component {
    static propTypes = {
        isDesktop: bool.isRequired,
        multipleSignaturesData: shape({}).isRequired,
    };

    getDescriptionLine = (activityName, transactionData) => {
        const showDataAdditionalEcomex = configUtils.getBoolean("frotend.show.divisa.amount.Ecomex", false);
        if (activityName === "Comercio Exterior" && showDataAdditionalEcomex) {
            const concept = transactionData?.concept;
            if (concept && String(concept).trim() !== "") {
                return String(concept).trim();
            }
            return activityName || "";
        }
        return activityName || "";
    };

    renderRow = (object) => {
        const { isDesktop } = this.props;
        const { transaction } = object;
        const { idTransaction, data = {}, submitDateTimeAsString, activityName } = transaction;
        const transactionData = data.transactionData || {};
        const showDivisaAmount = configUtils.getBoolean("frotend.show.divisa.amount.Ecomex", false);
        const showBeneficiary = configUtils.getBoolean("frontend.show.beneficiary.ecomex", false);
        const beneficiaryMaxLength = configUtils.getInteger("frontend.show.beneficiary.ecomex.maxLength", 100);
        const beneficiaryRaw = getEcomexBeneficiaryName(data);
        const beneficiaryNameToShow = truncateWithEllipsis(beneficiaryRaw || "", beneficiaryMaxLength);
        const descriptionLine = this.getDescriptionLine(activityName, transactionData);
        const showBeneficiaryTag = showBeneficiary && beneficiaryNameToShow && beneficiaryNameToShow.trim() !== "";
        const { currency, quantity } = getQuantityAndCurrency(object);

        const showDivisaRow = showDivisaAmount;

        const content = (
            <div className="send-external-transaction-card__motivo-row">
                <div className="send-external-transaction-card__first-line">
                    {descriptionLine ? (
                        <span className="ecomex-send-accept-transaction-card__description">{descriptionLine}</span>
                    ) : null}
                    {showBeneficiaryTag && (
                        <Tag
                            variant="info"
                            className="send-external-transaction-card__activity-tag ecomex-send-accept-transaction-card__beneficiary-tag">
                            <I18n id="ecomex.transaction.card.beneficiaryName" />
                            {"\u00a0"}
                            {beneficiaryNameToShow}
                        </Tag>
                    )}
                </div>
                {showDivisaRow && (
                    <div className="send-external-transaction-card__second-line ecomex-send-accept-transaction-card__divisa-row">
                        <span className="ecomex-send-accept-transaction-card__divisa-segment">
                            <I18n
                                componentProps={{
                                    className: "ecomex-send-accept-transaction-card__divisa-label",
                                }}
                                id="ecomex.transaction.data.requestCurrency"
                            />
                            <span className="ecomex-send-accept-transaction-card__divisa-suffix">{`: ${transactionData?.requestCurrency ??
                                ""}`}</span>
                        </span>
                        <span className="ecomex-send-accept-transaction-card__divisa-between" aria-hidden="true">
                            |
                        </span>
                        <span className="ecomex-send-accept-transaction-card__divisa-segment">
                            <I18n
                                componentProps={{
                                    className: "ecomex-send-accept-transaction-card__divisa-label",
                                }}
                                id="ecomex.transaction.data.requestAmount"
                            />
                            <span className="ecomex-send-accept-transaction-card__divisa-suffix">{`: ${formatEcomexRequestAmount(
                                transactionData?.requestAmount,
                            )}`}</span>
                        </span>
                    </div>
                )}
            </div>
        );

        return (
            <CardContainer key={idTransaction} className="confirmation__cards-container mt-0">
                <Card
                    isDesktop={isDesktop}
                    className="confirmation__cards send-external-transaction-card ecomex-send-accept-transaction-card"
                    icon={isDesktop && "images/transfer-PENDING.svg"}
                    iconClass="card__pending-transaction-icon"
                    hrClass="d-none"
                    title={
                        !isDesktop && (
                            <div>
                                {submitDateTimeAsString && (
                                    <div className="confirmation-cards__title">
                                        <div className="confirmation-cards__title-data">
                                            <I18n id="forms.transaction.ticket.date" />
                                        </div>
                                        <div className="confirmation-cards__title-info">
                                            <span>{submitDateTimeAsString}</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )
                    }
                    content={isDesktop ? content : <div>{content}</div>}
                    rightContent={
                        <div className="confirmation-cards__right">
                            <div className="confirmation-cards__right-data">
                                <FormattedAmount currency={currency} quantity={quantity} />
                            </div>
                        </div>
                    }
                />
            </CardContainer>
        );
    };

    dataRow = () => {
        const { multipleSignaturesData } = this.props;
        const { selectedTransactionRows } = multipleSignaturesData;
        return selectedTransactionRows.map((object) => this.renderRow(object));
    };

    render() {
        return this.dataRow();
    }
}

const mapStateToProps = (state) => ({
    multipleSignaturesData: transactionsSelectors.getMultipleSignaturesData(state),
});

export default connect(mapStateToProps)(withMultipleSignaturesContext(EcomexSendAcceptTransactionDataTable));
